import Cookies from 'js-cookie';

export const cookieStateAdapter = (cookieInput, supportedCookies) => {
  const cookieOutput = {};
  const isParsed = Object.values(cookieInput).some((value) => value === false);

  if (isParsed) {
    // delete all properties that whose value is false
    Object.keys(cookieInput).forEach((key) => {
      if (cookieInput[key]) {
        cookieOutput[key] = cookieInput[key];
      }
    });
  } else {
    supportedCookies.forEach((supportedCookie) => {
      cookieOutput[supportedCookie] = !!cookieInput[supportedCookie];
    });
  }
  return cookieOutput;
};

const findSubstringInString = (substring, string) => {
  if (typeof substring !== 'string' || typeof string !== 'string') {
    return false;
  }
  return string?.indexOf(substring) !== -1;
};

export const hasCookieConsent = (cookieType) => findSubstringInString(cookieType, Cookies.get('COOKIE_CONSENT'));
